
import { mapGetters, mapActions } from 'vuex'
import FilterColor from '.././filter-color'
import FilterSize from '.././filter-size'
import FilterCheckbox from '.././filter-checkbox'
import FilterListItem from './filterListItem.vue'
import ActiveFilterToggle from './activeFilterToggle.vue'
import SortBy from './sortyBy.vue'
import Backdrop from '~/components/common/backdrop'

export default {
  components: {
    Backdrop,
    FilterListItem,
    ActiveFilterToggle,
    SortBy,
    FilterColor,
    FilterSize,
    FilterCheckbox,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    filterFacets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      wording: null,
    }
  },
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
    }),
    totalResults() {
      return this.vxSearchResults.pagination.totalResults
    },
  },
  methods: {
    ...mapActions({
      vxResetAllSearch: 'search/resetAllSearch',
    }),
    getActiveFiltersCount(facet) {
      return facet.values.filter((item) => item.active).length
    },
  },
}
